import React from "react";

function PlusIcon({
  width = 12,
  height = 12,
  color = "white",
  className
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 6.66667H0.833333C0.597222 6.66667 0.399306 6.58681 0.239583 6.42708C0.0798611 6.26736 0 6.06944 0 5.83333C0 5.59722 0.0798611 5.39931 0.239583 5.23958C0.399306 5.07986 0.597222 5 0.833333 5H5V0.833333C5 0.597222 5.07986 0.399306 5.23958 0.239583C5.39931 0.0798611 5.59722 0 5.83333 0C6.06944 0 6.26736 0.0798611 6.42708 0.239583C6.58681 0.399306 6.66667 0.597222 6.66667 0.833333V5H10.8333C11.0694 5 11.2674 5.07986 11.4271 5.23958C11.5868 5.39931 11.6667 5.59722 11.6667 5.83333C11.6667 6.06944 11.5868 6.26736 11.4271 6.42708C11.2674 6.58681 11.0694 6.66667 10.8333 6.66667H6.66667V10.8333C6.66667 11.0694 6.58681 11.2674 6.42708 11.4271C6.26736 11.5868 6.06944 11.6667 5.83333 11.6667C5.59722 11.6667 5.39931 11.5868 5.23958 11.4271C5.07986 11.2674 5 11.0694 5 10.8333V6.66667Z"
        fill={color}
      />
    </svg>
  );
}

export default PlusIcon;